/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetSubmission200ResponseSchema } from '../models/GetSubmission200ResponseSchema';
import type { GetSubmissionRequestSchema } from '../models/GetSubmissionRequestSchema';
import type { GetSubmissionUrl200ResponseSchema } from '../models/GetSubmissionUrl200ResponseSchema';
import type { GetSubmissionUrlRequestSchema } from '../models/GetSubmissionUrlRequestSchema';
import type { Id } from '../models/Id';
import type { ListSubmissions200ResponseSchema } from '../models/ListSubmissions200ResponseSchema';
import type { ListSubmissionsRequestSchema } from '../models/ListSubmissionsRequestSchema';
import type { ListTeamSubmissions200ResponseSchema } from '../models/ListTeamSubmissions200ResponseSchema';
import type { ListTeamSubmissionsRequestSchema } from '../models/ListTeamSubmissionsRequestSchema';
import type { ListUserSubmissions200ResponseSchema } from '../models/ListUserSubmissions200ResponseSchema';
import type { ListUserSubmissionsRequestSchema } from '../models/ListUserSubmissionsRequestSchema';
import type { OkResponseSchema } from '../models/OkResponseSchema';
import type { SendSubmissionResultRequestSchema } from '../models/SendSubmissionResultRequestSchema';
import type { SendTeamSubmissionRequestSchema } from '../models/SendTeamSubmissionRequestSchema';
import type { SendUserSubmissionRequestSchema } from '../models/SendUserSubmissionRequestSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SubmissionsService {

    /**
     * getSubmission
     * get submission
     * @param requestBody
     * @returns GetSubmission200ResponseSchema GetSubmission200Response
     * @throws ApiError
     */
    public static getSubmission(
        requestBody?: GetSubmissionRequestSchema,
    ): CancelablePromise<GetSubmission200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/getSubmission',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `GetSubmission400Response`,
            },
        });
    }

    /**
     * listTeamSubmissions
     * list submissions team
     * @param requestBody
     * @returns ListTeamSubmissions200ResponseSchema ListTeamSubmissions200Response
     * @throws ApiError
     */
    public static listTeamSubmissions(
        requestBody?: ListTeamSubmissionsRequestSchema,
    ): CancelablePromise<ListTeamSubmissions200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listTeamSubmissions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListTeamSubmissions400Response`,
            },
        });
    }

    /**
     * listUserSubmissions
     * list submissions user
     * @param requestBody
     * @returns ListUserSubmissions200ResponseSchema ListUserSubmissions200Response
     * @throws ApiError
     */
    public static listUserSubmissions(
        requestBody?: ListUserSubmissionsRequestSchema,
    ): CancelablePromise<ListUserSubmissions200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listUserSubmissions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListUserSubmissions400Response`,
            },
        });
    }

    /**
     * sendTeamSubmission
     * send submission team
     * @param userId
     * @param taskId
     * @param teamId
     * @param requestBody
     * @returns OkResponseSchema SendTeamSubmission200Response
     * @throws ApiError
     */
    public static sendTeamSubmission(
        userId: Id,
        taskId: Id,
        teamId: Id,
        requestBody?: SendTeamSubmissionRequestSchema,
    ): CancelablePromise<OkResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sendTeamSubmission',
            query: {
                'userId': userId,
                'taskId': taskId,
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/javascript',
            errors: {
                400: `SendTeamSubmission400Response`,
            },
        });
    }

    /**
     * sendUserSubmission
     * send submission user
     * @param userId
     * @param taskId
     * @param requestBody
     * @returns OkResponseSchema SendUserSubmission200Response
     * @throws ApiError
     */
    public static sendUserSubmission(
        userId: Id,
        taskId: Id,
        requestBody?: SendUserSubmissionRequestSchema,
    ): CancelablePromise<OkResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sendUserSubmission',
            query: {
                'userId': userId,
                'taskId': taskId,
            },
            body: requestBody,
            mediaType: 'application/javascript',
            errors: {
                400: `SendUserSubmission400Response`,
            },
        });
    }

    /**
     * sendSubmissionResult
     * send submission result
     * @param requestBody
     * @returns OkResponseSchema SendSubmissionResult200Response
     * @throws ApiError
     */
    public static sendSubmissionResult(
        requestBody?: SendSubmissionResultRequestSchema,
    ): CancelablePromise<OkResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/sendSubmissionResult',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `SendSubmissionResult400Response`,
            },
        });
    }

    /**
     * getSubmissionUrl
     * get submission url
     * @param requestBody
     * @returns GetSubmissionUrl200ResponseSchema GetSubmissionUrl200Response
     * @throws ApiError
     */
    public static getSubmissionUrl(
        requestBody?: GetSubmissionUrlRequestSchema,
    ): CancelablePromise<GetSubmissionUrl200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/getSubmissionUrl',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `GetSubmissionUrl400Response`,
            },
        });
    }

    /**
     * listSubmissions
     * list submissions
     * @param requestBody
     * @returns ListSubmissions200ResponseSchema ListSubmissions200Response
     * @throws ApiError
     */
    public static listSubmissions(
        requestBody?: ListSubmissionsRequestSchema,
    ): CancelablePromise<ListSubmissions200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listSubmissions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListSubmissions400Response`,
            },
        });
    }

}
